import React from 'react';
import { IonToast } from '@ionic/react';
import { close } from 'ionicons/icons';

export type ToasterVariant = 'success' | 'warning' | 'error';

interface ToasterProps {
  isOpen: boolean;
  message?: string;
  variant?: ToasterVariant;
  persistent?: boolean;
  onDidDismiss: () => void;
}

const VARIANT_COLOR: Record<ToasterVariant, string> = {
  success: 'success',
  warning: 'warning',
  error: 'danger',
};

const VARIANT_DURATION_MS: Record<ToasterVariant, number> = {
  success: 1500,
  warning: 3000,
  error: 6000,
};

const Toaster: React.FC<ToasterProps> = ({
  isOpen,
  message,
  variant = 'success',
  persistent = false,
  onDidDismiss,
}) => (
  <IonToast
    isOpen={isOpen}
    message={message}
    color={VARIANT_COLOR[variant]}
    position="top"
    duration={persistent ? undefined : VARIANT_DURATION_MS[variant]}
    buttons={persistent ? [{ icon: close, role: 'cancel', htmlAttributes: { 'aria-label': 'Close' } }] : undefined}
    onDidDismiss={onDidDismiss}
  />
);

export default Toaster;
